var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.414,
    height: 17,
    viewBox: "0 0 18.414 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-check-square",
    "data-name": "Icon feather-check-square",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13907",
    "data-name": "Path 13907",
    d: "M13.5,11.928l2.541,2.54L24.509,6",
    transform: "translate(-8.509 -5.153)",
    fill: "none",
    stroke: "#0177b5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13908",
    "data-name": "Path 13908",
    d: "M19.653,12v5.833A1.675,1.675,0,0,1,17.969,19.5H6.184A1.675,1.675,0,0,1,4.5,17.833V6.167A1.675,1.675,0,0,1,6.184,4.5h9.26",
    transform: "translate(-4.5 -4.5)",
    fill: "none",
    stroke: "#0177b5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChecked);
export default __webpack_public_path__ + "static/media/icon-checked.a8cc737f6e4e901fa100c2286150211e.svg";
export { ForwardRef as ReactComponent };